import "cropperjs/dist/cropper.css";
import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Cropper from "react-cropper";
import { BiDownload, BiReset, BiRotateLeft, BiRotateRight } from "react-icons/bi";
import styles from "../styles/imageScaleAndCrop.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css"
import { ControlButton } from "./imageScaleControlButton";

import "react-image-crop/dist/ReactCrop.css";

export const ImageScaleAndCropComponent = ({
  setSrc,
  imageType,
  src,
  handleClose,
  dimensions = { width: 256, height: 256 },
}: {
  setSrc: any;
  imageType: "avatar" | "displayImage";
  src: string | null;
  handleClose: () => void;
  dimensions?: { width: number; height: number };
}) => {
  const [scale, setScale] = useState(1);
  const cropperRef = useRef<any | null>(null);

  const [imageSrc, setImageSrc] = useState<any | null>(src);
  const [croppedImage, setCroppedImage] = useState<any | null>(null);
  const aspectRatio = dimensions.width/dimensions.height;
  //const aspectRatio = 1;

  const onRotate = (direction: any) => () => {
    if (cropperRef.current && cropperRef.current.cropper) {
      let angle = direction === "left" ? -30 : 30;
      cropperRef.current.cropper.rotate(angle);
    }
  };

  const onScale = (e: any) => {
    const scaleValue = parseFloat(e.target.value);
    setScale(scaleValue);
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.scale(scaleValue);
    }
  };

  const onReset = () => {
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.reset();
      setScale(1);
    }
  };

  const onDownload = () => {
    const data = cropperRef.current.cropper.getCroppedCanvas();
    data.toBlob((blob: any) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "React Image Editor.jpg";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const onImageUpload = (e: any) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();

    reader.onload = (e: any) => {
      setImageSrc(e.target.result);
      //   if (cropperRef.current && cropperRef.current.cropper) {
      //     cropperRef.current.cropper.destroy();
      //   }
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = () => {
    // set the cropped image
    setSrc(cropperRef.current.cropper.getCroppedCanvas().toDataURL());
  };
  return (
    <Modal show={true} size="lg" centered={true}>
      <Modal.Body>
        <div className={styles.imageEditor}>
          <div>
            <Cropper
              src={imageSrc}
              style={{ height: 400, width: "100%" }}
              //style={{ height: dimensions.width, width: dimensions.height }}
              aspectRatio={aspectRatio}
              guides={false}
              ref={cropperRef}
              cropBoxResizable={false}
              dragMode="move"
            />
            <div className={styles.controlsBlock}>
              <ControlButton tooltip="Rotate Left" onClick={onRotate("left")}>
                <BiRotateLeft size={30} />
              </ControlButton>
              <ControlButton tooltip="Rotate Right" onClick={onRotate("right")}>
                <BiRotateRight size={30} />
              </ControlButton>
              <div className={styles.scaleFieldBlock}>
                <input
                  type="range"
                  min="0.01"
                  max="2"
                  step="0.01"
                  value={scale}
                  aria-label="scale"
                  id="scale"
                  onChange={onScale}
                />
                <label htmlFor="scale">Scale</label>
              </div>
              <ControlButton tooltip="Reset" onClick={onReset}>
                <BiReset size={30} />
              </ControlButton>
              <ControlButton tooltip="Download Image" onClick={onDownload}>
                <BiDownload size={30} />
              </ControlButton>
            </div>
            <div className={styles.imageUploadBlock}>
              {croppedImage && <img src={croppedImage} alt="Cropped Image" style={{ width: "100%", height: "100%" }} />}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className={btnStyles.Cancel} onClick={handleClose}>Close</button>
        <button className={btnStyles.Submit} onClick={handleSubmit}>Submit</button>
      </Modal.Footer>
    </Modal>
  );
};
